import { render, staticRenderFns } from "./FacetWrapper.vue?vue&type=template&id=200aab52&"
import script from "./FacetWrapper.vue?vue&type=script&lang=js&"
export * from "./FacetWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports